import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  financeTabHidden: true, // Finance tab is hidden by default
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleFinanceTab: (state) => {
      state.financeTabHidden = !state.financeTabHidden;
    },
    hideFinanceTab: (state) => {
      state.financeTabHidden = true;
    },
    showFinanceTab: (state) => {
      state.financeTabHidden = false;
    },
  }
});

export const { 
  toggleFinanceTab,
  hideFinanceTab,
  showFinanceTab
} = uiSlice.actions;

export default uiSlice.reducer;
